import UsersService from 'sharebase/services/usersService';
import {DeploymentNameService} from 'sharebase/services/deploymentNameService';
import { 
	PhoenixUser,
	PhoenixUserGroup,
	isPhoenixUser,
	isUserGroup
} from 'phoenix/domain';
import { ShareBaseDialog } from 'sharebase/domain';
import { 
	AuthService, 
	ProgressService 
} from 'phoenix/services';

require('./userListSelectDialog.styles');
const template = require('./userListSelectDialog.template');

type Selectable = PhoenixUser|PhoenixUserGroup;
export class UserSelectListDialog extends ShareBaseDialog{
	public static $inject: string[] = [
		'$q',
		'$mdDialog',
		'$mdMedia',
		'$filter',
		'sbDeploymentNameService',
		'sbUsersService',
		'sbUserGroupsService',
		'pxAuthService',
		'pxProgressService',
		'gettextCatalog'
	];

	public items:Selectable[] = [];
	public selected:Selectable[] = [];
	public showUsers:boolean = false;
	public showGroups:boolean = false;
	private loading:boolean = false;

	constructor(
		private readonly $q:ng.IQService,
		$mdDialog,
		$mdMedia,
		private readonly $filter:ng.IFilterService,
		private readonly sbDeploymentNameService:DeploymentNameService,
		private readonly sbUsersService:UsersService,
		private readonly sbUserGroupsService,
		private readonly pxAuthService:AuthService,
		private readonly pxProgressService:ProgressService,
		private readonly gettextCatalog:ng.gettext.gettextCatalog,
	) {
		super($mdDialog, template, gettextCatalog.getString('Select users and groups'), $mdMedia('xs'))
	}


	public open(e:ng.IAngularEvent, selected:Selectable[], showUsers:boolean, showGroups:boolean){
		this.pxProgressService.visible = true;
		this.pxProgressService.text = this.gettextCatalog.getString('Building List');

		this.selected = selected;
		this.showUsers = showUsers;
		this.showGroups = showGroups;

		if(this.showUsers && this.showGroups){
			this.title = this.gettextCatalog.getString('Select users and groups');
		}
		else if(this.showUsers && !this.showGroups){
			this.title = this.gettextCatalog.getString('Select users');
		}
		else if(!this.showUsers && this.showGroups){
			this.title = this.gettextCatalog.getString('Select groups');
		}
		
		let initTasks = [];
		this.items = [];
		this.loading = true;
		if(this.showUsers){
			initTasks.push(this.sbDeploymentNameService
				.resolveSystemName(this.pxAuthService.deploymentId)
				.then(systemName => this.sbUsersService.getUsers(systemName, false))
				.then((users) => {
					this.items = this.items.concat(users);
				}));
		}
		if(this.showGroups){
			initTasks.push(this.sbDeploymentNameService
				.resolveSystemName(this.pxAuthService.deploymentId)
				.then(systemName => this.sbUserGroupsService.getUserGroups(systemName))
				.then((groups) =>{
					this.items = this.items.concat(this.$filter('orderBy')(groups, 'UserGroupName'))
				}));
		}

		this.$q
			.all(initTasks)
			.finally(() => {
				this.pxProgressService.visible = false;
			}
		);

		return super.open(e);
	}

	public dismiss(){
		super.dismiss(this.selected);
	}
	
	public transformItems = (i:Selectable) => {
		if(isPhoenixUser(i)){
			return {
				value: i.UserName,
				detail: i.EmailAddress,
				selected: this.selected
					.filter(u => isPhoenixUser(u))
					.some((u:PhoenixUser) => i.UserId === u.UserId)
			};
		}
		else {
			return {
				value: i.UserGroupName,
				detail: this.gettextCatalog.getString('User Group'),
				selected: this.selected
					.filter(u => isUserGroup(u))
					.some((u:PhoenixUserGroup) => i.UserGroupId === u.UserGroupId)
			}
		};
	}

	// maintain scope with arrow function instead of class method
	public onUserSelect = (selected:(Selectable)[]) => {
		this.selected = selected;
	};
}


// WEBPACK FOOTER //
// ./src/sharebase/components/userListSelectDialog/userListSelectDialog.ts